import { ErpAdditionalMessageDto } from './../../common/model/erpadditionalmessagedto';
import { JobApplication } from 'app/rm/erp/jobapplication/model/jobapplication';
import { JobApplicationAndDocuments } from './../model/jobapplicationanddocuments';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { HisBackendService } from 'hisng';
import { BwmConfig } from './../model/bwmconfig';

@Injectable()
export class JobApplicationService {

    constructor( private readonly backendService: HisBackendService ) { }

    /**
     * Gets the form configuration
     *
     * @returns the BwmConfig
     */
    getJobApplicationConfig( id: number ): Observable<BwmConfig> {
        return this.backendService.getData( 'api/v1/rm/erp/jobapplication/config/' + id );
    }

    /**
     * Save job application.
     *
     * @param applicationAndDocuments The JobApplication and Documents to save.
     */
    createJobApplication( applicationAndDocuments: JobApplicationAndDocuments ): Observable<ErpAdditionalMessageDto<JobApplication>> {
        if ( applicationAndDocuments.application.id == null ) {
            return this.backendService.postData( 'api/v1/rm/erp/jobapplication', applicationAndDocuments );
        } else {
            return EMPTY;
        }
    }

    validateJobApplication( applicationAndDocuments: JobApplicationAndDocuments ): Observable<number> {
        return this.backendService.postData( 'api/v1/rm/erp/jobapplication/validate', applicationAndDocuments );
    }
}
